import {
  ListItemText,
  MenuItem,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { isTestEnvironment } from 'helpers/environmentUtils';
import { useContext, useState } from 'react';
import { useLocation } from 'react-router';

import { CountryIconResolver } from '@/components';
import { CountryContext } from '@/contexts';
import { logout } from '@/helpers';
import {
  AvailableCountries,
  type AvailableCountry,
  CountryName,
} from '@/models';

export const CountryDialog = () => {
  const theme = useTheme();
  const location = useLocation();

  const [devModeEnabled, setDevModeEnabled] = useState<boolean>(false);

  const { setCountry } = useContext(CountryContext);

  if (location.pathname !== '/' || !isTestEnvironment) {
    return null;
  }

  if (!devModeEnabled) {
    return (
      <div
        aria-hidden
        onDoubleClick={() => setDevModeEnabled(true)}
        style={{ height: '40px', position: 'absolute', width: '40px' }}
      ></div>
    );
  }

  const handleCountrySelect = async (code: AvailableCountry) => {
    await logout();
    setCountry(code);
    localStorage.setItem('country', code);
  };

  return (
    <Stack
      bgcolor={'primary.main'}
      border={1}
      borderColor={'primary.contrastText'}
      borderRadius={0.2}
      bottom={0}
      display={'flex'}
      gap={3}
      left={0}
      margin={4}
      padding={2}
      position={'absolute'}
    >
      <MenuItem>
        <Typography color="primary.contrastText" variant="h3">
          Country
        </Typography>
      </MenuItem>
      <Stack bgcolor={'secondary.main'} borderRadius={0.2}>
        {AvailableCountries.map((code) => (
          <MenuItem
            key={code}
            onClick={() => handleCountrySelect(code)}
            value={code}
          >
            <Stack
              alignItems="center"
              flexDirection="row"
              gap={theme.spacing(2)}
            >
              <CountryIconResolver countryCode={code} />
              <ListItemText>
                <Typography color="secondary.contrastText">
                  {CountryName[code]}
                </Typography>
              </ListItemText>
            </Stack>
          </MenuItem>
        ))}
      </Stack>
    </Stack>
  );
};
